module.exports = __webpack_public_path__ + "static/media/shelter_beach_marker.f0e5c1b9.svg";